module.exports = __webpack_public_path__ + "73ea4a2fbfedc9730f2efecd962f5169.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-3.png
// module id = 1184
// module chunks = 0